import { render, staticRenderFns } from "./GridDropdownMenu.vue?vue&type=template&id=f631d0c8&scoped=true&"
import script from "./GridDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./GridDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./GridDropdownMenu.vue?vue&type=style&index=0&id=f631d0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f631d0c8",
  null
  
)

export default component.exports